import script from "./CustomerSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSelect.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSelect.vue?vue&type=style&index=0&id=6b14bd9c&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b14bd9c"]])

export default __exports__